<template lang="pug">
#bloco-evolucao-monitoramento-agricola
    h3 {{ $t('mensagens.monitoramentoAgricola.evolucaoColheita') }}
    .margem-progresso
        .posicao-div
            div
                h3.fonte-cor {{ evolucaoArea.colhido }}
            div
                h3.fonte-cor {{ evolucaoArea.pendente }}

        el-progress(
            color='var(--secondary-two)',
            :show-text='false',
            :stroke-width='50',
            :percentage='evolucaoArea.percentualColhido'
        )
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'BlocoEvolucaoMonitoramentoAgricola',
    props: {
        filtros: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            evolucaoArea: {
                colhido: this.$t('mensagens.monitoramentoAgricola.colhido'),
                pendente: this.$t('mensagens.monitoramentoAgricola.pendente')
            }
        };
    },
    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters(['culturaFiltrada'])
    },

    watch: {
        filtros() {
            if (this.usuarioLogado) {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/agricola/calcular-evolucao-colheita`,
                    response => {
                        if (this.filtros.idCulturas.length > 0) {
                            this.evolucaoArea = JSON.parse(response);
                        } else {
                            this.resetEvolucao();
                        }
                    }
                );
            }
        }
    },

    async mounted() {
        // TODO: REFATORAR PARA USAR API REST AO INVES DE SOCKET
        await connect();
        if (this.culturaFiltrada) {
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/agricola/calcular-evolucao-colheita`,
                response => {
                    if (this.filtros.idCulturas.length > 0) {
                        this.evolucaoArea = JSON.parse(response);
                    } else {
                        this.resetEvolucao();
                    }
                }
            );
        }
    },

    beforeDestroy() {
        disconnect();
    },

    methods: {
        resetEvolucao() {
            this.evolucaoArea = {
                colhido: this.$t('mensagens.monitoramentoAgricola.colhido'),
                pendente: this.$t('mensagens.monitoramentoAgricola.pendente')
            };
        }
    }
};
</script>
<style lang="scss" scoped>
#bloco-evolucao-monitoramento-agricola {
    .margem-progresso {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    ::v-deep .el-progress-bar__inner {
        border-radius: 0px;
    }

    ::v-deep .el-progress-bar__outer {
        background-color: var(--white) !important;
        border-radius: 0px;
    }

    .posicao-div {
        display: flex;
        justify-content: space-between;
    }

    .fonte-cor {
        color: var(--primary);
    }
}
</style>
